import React, { useEffect, useRef, useState } from 'react'
import moment from 'moment'
import MonthInput from './DateInputElements/MonthInput'
import YearInput from './DateInputElements/YearInput'
import DayInput from './DateInputElements/DayInput'
import useDate from './useDate'
import useInput from '../useInput'
import { Button } from '../../../index'

const DateInput = (props) => {
    const containerRef = useRef(null)
    const {
        date,
        delimiter = '/',
        day,
        month,
        year,
        setDate,
        setDay,
        setMonth,
        setYear,
        isDisabled,
        depth,
        format,
    } = props
    const [d, setD] = useState(depth === 'day' ? null : 1)
    const [m, setM] = useState(depth !== 'year' ? null : 0)
    const [y, setY] = useState(null)
    const [isInvalid, setInvalid] = useState(false)

    useEffect(() => {
        const _date = moment([y, m, d])
        if (_date.isValid() && date !== _date.toDate()) {
            setDate(_date.toDate())
        }
        if (y !== null && y !== undefined && d !== null && d !== undefined && m !== null && m !== undefined) {
            // const date = moment([y, m, d])
            // if (date.isValid()) {
            //     setDate(date.toDate())
            //     setInvalid(false)
            // } else {
            //     setInvalid(true)
            // }
        }
    }, [d, m, y])

    const focusNextInput = (index) => () => {
        setTimeout(() => {
            const nextInput = containerRef.current.querySelector('input[data-index="' + (index + 1) + '"]')
            if (nextInput) {
                nextInput.focus()
            }
        })
    }

    const renderInputs = () => {
        const formatEl = format.split(delimiter)
        return formatEl.map((f, i) => {
            const divider = i <= formatEl.length - 2 ? <span className='r-divider'>/</span> : ''
            const unitType = f.toLowerCase()
            const showMonth = depth ? depth !== 'year' : false
            const showDay = depth ? depth === 'day' : false
            const isMonth = unitType.indexOf('m') !== -1
            const isYear = unitType.indexOf('y') !== -1
            const isDay = unitType.indexOf('d') !== -1

            if ((isDay && !showDay) || (isMonth && !showMonth)) {
                return null
            }
            return (
                <React.Fragment key={i}>
                    {unitType.indexOf('m') !== -1 && showMonth ? (
                        <MonthInput
                            index={i}
                            isDisabled={isDisabled}
                            focusNextInput={focusNextInput(i)}
                            format={f}
                            value={month}
                            onChange={(v) => {
                                setMonth(v)
                                setM(parseInt(v))
                            }}
                        />
                    ) : (
                        ''
                    )}
                    {unitType.indexOf('y') !== -1 ? (
                        <YearInput
                            index={i}
                            isDisabled={isDisabled}
                            focusNextInput={focusNextInput(i)}
                            format={f}
                            value={year}
                            onChange={(v) => {
                                setYear(v)
                                // setYear(parseInt(v))
                                setY(parseInt(v))
                            }}
                        />
                    ) : (
                        ''
                    )}
                    {unitType.indexOf('d') !== -1 && showDay ? (
                        <DayInput
                            index={i}
                            isDisabled={isDisabled}
                            focusNextInput={focusNextInput(i)}
                            format={f}
                            value={day}
                            onChange={(v) => {
                                setDay(v)
                                setD(parseInt(v))
                                // setDay(parseInt(v))
                            }}
                        />
                    ) : (
                        ''
                    )}
                    {divider}
                </React.Fragment>
            )
        })
    }

    return (
        <div className={`r-dateinput-container ${isInvalid ? 'r-state-invalid' : ''}`} ref={containerRef}>
            {renderInputs()}
        </div>
    )
}

export default DateInput

// import moment from 'moment'
// import useInput from '../useInput'
// import { DateInputProps } from './Datepicker/Datepicker'
// const getWidth = (format) => {
//     const length = format.length
//     let width = 30
//     if (length === 2) {
//         width = 22
//     } else if (length === 3) {
//         width = 38
//     } else if (length === 4) {
//         width = 38
//     }
//
//     return width + 'px'
// }
//
// const MonthInput = ({ focusNextInput, index, format, value, onChange }) => {
//     const node = useRef(null)
//     const [internalValue, setValue] = useState(!isNaN(value) ? value : null)
//     const style = {
//         width: getWidth(format),
//     }
//
//     const handleChange = (e) => {
//         const textVal = e.target.value
//         let val
//
//         if (textVal === '') {
//             val = ''
//         } else {
//             val = parseInt(e.target.value)
//
//             if (!(val <= 12) && val >= 1) {
//                 return
//             }
//         }
//
//         setValue(val)
//
//         if (textVal.length === format.length) {
//             focusNextInput()
//         }
//     }
//
//     return (
//         <input
//             ref={node}
//             data-index={index}
//             style={style}
//             className='r-dateinput-date-el'
//             value={internalValue}
//             onFocus={(e) => {
//                 node.current.select()
//             }}
//             onChange={handleChange}
//             onBlur={(e) => onChange(internalValue)}
//             placeholder={'MM'}
//         />
//     )
// }
//
// const DayInput = ({ focusNextInput, index, format, value, onChange }) => {
//     const node = useRef(null)
//     const [internalValue, setValue] = useState(!isNaN(value) ? value : null)
//     const style = {
//         width: getWidth(format),
//     }
//
//     const handleChange = (e) => {
//         const textVal = e.target.value
//         let val
//
//         if (textVal === '') {
//             val = null
//         } else {
//             val = parseInt(e.target.value)
//
//             if (!(val <= 31)) {
//                 return
//             }
//         }
//         if (textVal.length === format.length) {
//             focusNextInput()
//         }
//
//         setValue(val)
//     }
//
//     return (
//         <input
//             ref={node}
//             data-index={index}
//             style={style}
//             className='r-dateinput-date-el'
//             type='number'
//             value={internalValue}
//             onChange={handleChange}
//             onFocus={(e) => {
//                 node.current.select()
//             }}
//             onBlur={(e) => onChange(internalValue)}
//             placeholder={'DD'}
//         />
//     )
// }
//
// const YearInput = ({ focusNextInput, index, format, value, onChange }) => {
//     const node = useRef(null)
//     const [internalValue, setValue] = useState(!isNaN(value) ? value : null)
//     const style = {
//         width: getWidth(format),
//     }
//
//     const handleChange = (e) => {
//         const textVal = e.target.value
//         let val
//
//         if (textVal === '') {
//             val = null
//         } else {
//             val = parseInt(e.target.value)
//
//             if (!(val <= 9999)) {
//                 return
//             }
//         }
//         if (textVal.length === format.length) {
//             focusNextInput()
//         }
//
//         setValue(val)
//     }
//
//     return (
//         <input
//             ref={node}
//             data-index={index}
//             style={style}
//             className='r-dateinput-date-el'
//             type='number'
//             value={internalValue}
//             onChange={handleChange}
//             onFocus={(e) => {
//                 node.current.select()
//             }}
//             onBlur={(e) => {
//                 onChange(internalValue)
//             }}
//             placeholder={format.toUpperCase()}
//         />
//     )
// }
//
// const DateInput = React.forwardRef<HTMLElement, DateInputProps>((props, ref) => {
//     const { delimiter = '/', format = 'MM/DD/YYYY' } = props
//     const { value, onChange, inputRender } = useInput(props, 'date')
//     const containerRef = useRef(null)
//     const parseDateEls = (value) => {
//         const date = moment(value, format).toDate()
//         return {
//             _day: date?.getDate() ?? null,
//             _month: date?.getMonth() ?? null,
//             _year: date?.getFullYear() ?? null,
//         }
//     }
//     const { _day, _month, _year } = parseDateEls(value)
//     const [day, setDay] = useState(_day)
//     const [month, setMonth] = useState(_month)
//     const [year, setYear] = useState(_year)
//     const [constructedDate, setConstructedDate] = useState(value || null)
//
//     useEffect(() => {
//         constructDate()
//     }, [day, month, year])
//
//     useEffect(() => {
//         onChange(constructedDate)
//     }, [constructedDate])
//
//     const focusNextInput = (index) => () => {
//         setTimeout(() => {
//             const nextInput = containerRef.current.querySelector('input[data-index="' + (index + 1) + '"]')
//             if (nextInput) {
//                 nextInput.focus()
//             }
//         })
//     }
//
//     const constructDate = () => {
//         if (day && month && year) {
//             setConstructedDate(moment([year, month - 1, day]).toDate())
//         }
//     }
//
//     const renderInputs = () => {
//         const formatEl = format.split(delimiter)
//
//         return formatEl.map((f, i) => {
//             const divider = i <= formatEl.length - 2 ? <span className='r-divider'>/</span> : ''
//             const unitType = f.toLowerCase()
//             return (
//                 <React.Fragment key={i}>
//                     {unitType.indexOf('m') !== -1 ? (
//                         <MonthInput
//                             index={i}
//                             focusNextInput={focusNextInput(i)}
//                             format={f}
//                             value={month}
//                             onChange={setMonth}
//                         />
//                     ) : (
//                         ''
//                     )}
//                     {unitType.indexOf('y') !== -1 ? (
//                         <YearInput
//                             index={i}
//                             focusNextInput={focusNextInput(i)}
//                             format={f}
//                             value={year}
//                             onChange={setYear}
//                         />
//                     ) : (
//                         ''
//                     )}
//                     {unitType.indexOf('d') !== -1 ? (
//                         <DayInput
//                             index={i}
//                             focusNextInput={focusNextInput(i)}
//                             format={f}
//                             value={day}
//                             onChange={setDay}
//                         />
//                     ) : (
//                         ''
//                     )}
//                     {divider}
//                 </React.Fragment>
//             )
//         })
//     }
//     return inputRender(
//         <div ref={ref} className={'r-input-base '}>
//             <div className={'r-dateinput-container'} ref={containerRef}>
//                 {renderInputs()}
//             </div>
//             {/*<div>Day: {day}</div>*/}
//             {/*<div>Month: {month}</div>*/}
//             {/*<div>Year: {year}</div>*/}
//         </div>,
//     )
// })
//
// export default DateInput
